/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { MyAsiAuthSystemInfoControllerService } from './services/my-asi-auth-system-info-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    MyAsiAuthSystemInfoControllerService,
    ApiConfiguration
  ],
})
export class MyasiAuthSysteminfoModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<MyasiAuthSysteminfoModule> {
    return {
      ngModule: MyasiAuthSysteminfoModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: MyasiAuthSysteminfoModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('MyasiAuthSysteminfoModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
